import { defineComponent as _defineComponent } from 'vue'
import { defineMessages } from '@/lib/i18n';
import { DynamicList } from '@/interfaces/model/general/dynamicList';
import { computed } from 'vue';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkResumeDynamicListDialog',
  props: {
    value: { type: Boolean },
    selectedDynamicLists: null
  },
  emits: ["input", "resume"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'resume'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  selectedDynamicLists: DynamicList[];
};

const m = defineMessages({
  resumeUpdateHeader: '選択した{count}件の更新を再開しますか?',
  resumeUpdateContent:
    '「実行する」をクリックすると、選択された{count}件のチェックリストの更新を再開します。',
});




const model = computed({
  get: () => props.value,
  set: (value) => emit('input', value),
});

const closeDialog = () => {
  model.value = false;
};

const handleResumeClick = () => {
  emit('resume');
  closeDialog();
};

const handleCancelClick = () => {
  closeDialog();
};

return { __sfc: true,m, props, emit, model, closeDialog, handleResumeClick, handleCancelClick, BaseFormCard, sharedMessages }
}

})